export default __webpack_public_path__ + "static/media/Thumbs.5a1298c8.db";